import React from 'react';
import {useDroppable} from '@dnd-kit/core';

export function Droppable(props) {
  const {isOver, setNodeRef} = useDroppable({
    id: props.id,
  });
  const style = {
    backgroundColor: isOver ? 'rgba(49, 220, 123, 0.33)' : undefined,
  };
  
  
  return (
    <div className={`droppable ${props.className || 'choice'}`} ref={setNodeRef} style={style}>
      {props.children}
    </div>
  );
}